// NPM Imports
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

// action imports
import showNavbar from "../../../actions/NavbarWrapperAction";

// Image Imports
import errorImage from "../../../assets/fourofour.png";

class DocumentError404 extends Component {
  state = {};

  componentDidMount() {
    this.props.showNavbar(true);
  }

  componentWillUnmount() {
    this.props.showNavbar(false);
  }

  render() {
    return (
      <div className="document-error-404-wrapper">
        <img src={errorImage} alt="" />
        <div className="document-error-404-body">
          <span className="document-error-404-title">
            Uh oh! We couldn&apos;t find the document you&apos;re looking for.
          </span>
          <span className="document-error-404-msg">
            This happens when the owner has deleted the document or may not have
            given you permission to access it.
            <Link to="/assets">Go to your Documents</Link>
          </span>

          <span className="document-error-404-tip">
            <span aria-label="bulb" role="img">
              &#128161;
            </span>{" "}
            Tip: If you have multiple Revv accounts, ensure that you&apos;re
            logged into the right one to view the document.
          </span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { showNavbar };

export default connect(
  null,
  mapDispatchToProps,
)(DocumentError404);



// WEBPACK FOOTER //
// ./src/components/ErrorComponents/DocumentError404/index.js